/** Copyright 2025 SAP SE or an SAP affiliate company. All rights reserved. */

import { useCallback, useState } from 'react';

/**
 * Custom hook that manages the open/close state.
 *
 * @returns A tuple containing:
 * - `isOpen`: A boolean indicating whether the state is open or not.
 * - `toggle`: A function to toggle the open/close state.
 */
export default function useOpen() {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = useCallback(() => setIsOpen(!isOpen), [isOpen]);

    return [isOpen, toggle] as const;
}
